// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Breadcrumbs, Grid, Link } from '@mui/material';
import { Icons } from 'greener-ui-library';
import { useBreakpoint } from 'hooks/useBreakpoint';
import useBreadcrumbs, { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

export function Breadcrumb({ routes = [] }: { routes?: BreadcrumbsRoute[] }) {
  const breadcrumbs = useBreadcrumbs(routes);
  const { isMobile } = useBreakpoint();
  const { pathname } = useLocation();

  return (
    <Box sx={{ overFlow: 'hidden', pb: 2 }}>
      <Grid container>
        <Grid item>
          <Breadcrumbs
            key={pathname}
            separator={<Icons.NavigateNext fontSize="small" sx={{ color: 'grey.500' }} />}
            aria-label="breadcrumb"
            {...(isMobile && { maxItems: 2, itemsBeforeCollapse: 0, itemsAfterCollapse: 2 })}
          >
            {breadcrumbs
              .filter((item) => item.breadcrumb !== '' && item.key !== '/')
              .map(
                ({ match, breadcrumb }, i) =>
                  breadcrumb !== '' && (
                    <Link
                      key={match.pathname}
                      variant="body1"
                      to={match.pathname}
                      component={RouterLink}
                      sx={{
                        textDecoration: 'none',
                        color: i === breadcrumbs.length - 1 ? 'grey.700' : 'grey.500',
                        '&:hover': {
                          color: i === breadcrumbs.length - 1 ? 'grey.900' : 'grey.700',
                        },
                      }}
                    >
                      {breadcrumb}
                    </Link>
                  )
              )}
          </Breadcrumbs>
        </Grid>
      </Grid>
    </Box>
  );
}
